import { Link } from 'react-router-dom';

const footerLinks = {
  explore: {
    title: '探索内容',
    links: [
      { label: '热门电影', path: '/category/movie' },
      { label: '热门电视剧', path: '/category/tv' },
      { label: '热门综艺', path: '/category/variety' },
      { label: '热门动漫', path: '/category/anime' },
      { label: '最新上线', path: '/category/all' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '用户口碑', path: '/about#reviews' },
      { label: '联系方式', path: '/about#contact' },
    ],
  },
  help: {
    title: '帮助支持',
    links: [
      { label: '常见问题', path: '/about' },
      { label: '播放帮助', path: '/about' },
      { label: '意见反馈', path: '/about#contact' },
    ],
  },
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 border-t border-background-200/10" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center gap-3 mb-4 group">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg transition-transform duration-300 group-hover:scale-105">
                  <i className="ri-movie-2-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-bold font-heading text-foreground-50 tracking-wide">
                  春夜影院
                </span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                春夜影院提供最新电影全集与电视剧大全，免费高清在线观看，蓝光画质，不缓冲流畅播放，享受沉浸式观影体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-300 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-300 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-300 cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line text-sm"></i>
                </a>
              </div>
            </div>

            {/* Links */}
            {Object.values(footerLinks).map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-foreground-100 mb-4">
                  {section.title}
                </h4>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-300"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 pt-6 border-t border-background-200/10">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-600">
                &copy; {currentYear} 春夜影院 ChunYeCinema.com 版权所有
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-600">
                <span>本站内容仅供交流学习</span>
                <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
                <span>24小时不间断更新</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}